<template>
    <div>
        <div class="review--block--header" @click="() => { this.$emit('toggled', { selected: this.selected }) }">
            <div class="review--block--header--icon" v-html="airplane"></div>
            <div class="review--block--header--title">
                <div>
                    {{ service.details.title }}
                </div>
            </div>
            <div class="review--block--header--checked" v-html="checked"></div>
        </div>
        <div v-show="opened">
            <div class="panel tiny-mce" transparent noradius noshadow v-if="service.public_data.service_notes" v-html="service.public_data.service_notes"></div>
            <review-agent-notes v-if="service.public_data.agent_notes" :agent_notes="service.public_data.agent_notes" />
            <div class="panel" noradius>
                <review-service-highlight
                    :price="service.public_data.public_price"
                    :departure_date="details.departure"
                    :return_date="details.return"
                    :adults="this.$store.state.quote.details.occupancy ? this.$store.state.quote.details.occupancy.adults : ''"
                    :children="this.$store.state.quote.details.occupancy ? this.$store.state.quote.details.occupancy.children : []"
                />                
            </div>
            <div class="review--block--body" v-if="service.details.itineraries.length > 0">
                <b-form-radio-group v-model="selected">
                    <div v-for="itinerary in service.details.itineraries" v-bind:key="itinerary.itinerary_index">
                        <div class="review--option">
                            <div class="review--option--content">
                                <b-row class="review--flight">
                                    <b-col sm="12">
                                        <div class="review--option--title">
                                            <b-badge variant="primary">{{ parse_flight_offers_date(itinerary.segments[0].departure.at).readable_datetime | \moment("DD-MM-YYYY") }}</b-badge>
                                            {{ iata_airport_to_name(itinerary.segments[0].departure.iataCode) }} - {{ iata_airport_to_name(itinerary.segments[itinerary.segments.length - 1].arrival.iataCode) }}
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row class="review--flight--segments">
                                    <b-col md="6" lg="4" xl="3" v-if="false">
                                        <div class="review--option--info">
                                            <!--<strong>durata complessiva: </strong> {{ itinerary.duration }}--> <!-- TODO -->
                                        </div>
                                    </b-col>
                                    <b-col md="6" lg="8" xl="9" class="review--option--segment">
                                        <b-row class="mb-2" v-for="(segment,index) in itinerary.segments" v-bind:key="index">
                                            <b-col md="4">
                                                {{ iata_carrier_to_name(segment.carrierCode) }} <!-- TODO -->
                                                <div v-if="segment.operating.carrierCode">(operato da {{ iata_carrier_to_name(segment.operating.carrierCode) }})</div>
                                                <br/><strong v-if="segment.flight_number">numero volo</strong> {{ segment.flight_number }}
                                            </b-col>
                                            <b-col md="8">
                                                <strong>partenza: </strong> {{ iata_airport_to_name(segment.departure.iataCode) }} {{ parse_flight_offers_date(segment.departure.at).readable_datetime }}
                                                <br>
                                                <strong>arrivo: </strong> {{ iata_airport_to_name(segment.arrival.iataCode) }} {{ parse_flight_offers_date(segment.arrival.at).readable_datetime }}
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </div>
                            <div class="review--option--control">
                                <b-form-radio v-model="selected" name="review-flights" :value="itinerary.itinerary_index"></b-form-radio>
                            </div>
                        </div>
                    </div>
                </b-form-radio-group>
            </div>
            <div class="panel" transparent noradius noshadow v-if="service.public_data.public_notes">
                <div class="review--title--small">
                    <strong>Note, istruzioni e condizioni della soluzione</strong>
                </div>
                <div class="tiny-mce" v-html="service.public_data.public_notes"></div>
            </div>
            <!--
            <div class="review--block--footer">
                <button-with-icon
                    variant="cta"
                    text="Chiudi"
                    :disabled="selected == -1"
                    :icon="chevron_right"
                    :clicked="() => { this.$emit('completed', { selected: this.selected }) }"
                />
            </div>-->
        </div>
    </div>
</template>

<script>
    //import Bwi from '@/components/atoms/button-with-icon'
    import ReviewServiceHighlight from '@/components/review/review-service-highlight'
    import ReviewAgentNotes from '@/components/review/review-agent-notes'
    //import { validate_fields } from '@/validate'
    import { airplane, checked, info } from '@/components/svg/common'
    import { chevron_right } from '@/components/svg/chevrons'
    import { parse_flight_offers_date } from '@/utilities'

    export default {
        name: 'review-flight',
        components: {
            //'button-with-icon': Bwi,
            'review-service-highlight': ReviewServiceHighlight,
            'review-agent-notes': ReviewAgentNotes,
        },
        props:
        {
            opened: {
                type: Boolean,
                default: false,
            },            
            service: {
                type: Object,
                default: () => {}
            },
            quote_dictionaries: {
                type: Object,
                default: () => {}
            },
            details: {
                type: Object,
                default: () => {}
            }
        },
        created()
        {
            this.airplane = airplane
            this.checked = checked
            this.info = info
            this.chevron_right = chevron_right
            //this.validate_fields = validate_fields

            this.parse_flight_offers_date = parse_flight_offers_date
        },
        data() {
            return {
                selected: 0,//-1,
                options: [],
                dictionaries: (this.quote_dictionaries)? this.quote_dictionaries : {}
            }
        },
        computed: {
        },
        mounted() {
            this.$emit('completed', { selected: this.selected })
            this.service.details.itineraries.forEach(itinerary => {
                this.options.push(itinerary.itinerary_index)
            })
        },
        methods:{
            iata_airport_to_name(iata_code) {
                iata_code = iata_code.toUpperCase()
                if(!this.dictionaries.airports) return iata_code
                if(!this.dictionaries.airports[iata_code]) return iata_code
                return this.dictionaries.airports[iata_code].name
            },
            iata_carrier_to_name(iata_code) {
                iata_code = iata_code.toUpperCase()
                if(!this.dictionaries.carriers) return iata_code
                if(!this.dictionaries.carriers[iata_code]) return iata_code
                return this.dictionaries.carriers[iata_code].name
            },
        },
    }
</script>

<style lang="scss">
    #review-flight
    {
        .review--option--title
        {
            text-transform: uppercase;
            margin-bottom:1rem;
            display:flex;
            flex-wrap: wrap;
            align-content: center;
            .badge
            {
                margin-right:0.75rem;
            }
        }
        .review--option--segment
        {
            margin-bottom:$grid-gutter-width/4;
        }
    }
</style>